module.exports = __webpack_public_path__ + "static/Marco-Farina-7e1cd8db95ce053e6ded7829ef9ffbeb.png";